import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { navigateTo, selectMobileActiveScreen } from "../../app/slice/mobileSlice";
import { selectAppState } from "../../app/slice/appSlice";
import MobileLocationsScreen from "./MobileLocationsScreen";
import MobileConditionsScreen from "./MobileConditionsScreen";
import MobileSlotsScreen from "./MobileSlotsScreen";
import MobileBottomSheet from "./MobileBottomSheet";
import { APP_PLATFORM } from "../../config";
import ReviewStickyWidgetV2 from "../ReviewCollector/ReviewStickyWidgetV2";
import { Platform } from "../../models";
import { useEffect, useRef } from "react";

const MobileFlowBuilder = () => {
  const dispatch = useAppDispatch();
  const activeScreen = useAppSelector(selectMobileActiveScreen);
  const { loading } = useAppSelector((state) => state.mobile);
  const { loading: appLoading, isMobile } = useAppSelector(selectAppState);
  const wasMobileRef = useRef(isMobile);
  const renderScreen = () => {
    switch (activeScreen) {
      case "locations":
        return <MobileLocationsScreen />;
      case "conditions":
        return <MobileConditionsScreen />;
      case "slots":
        return <MobileSlotsScreen />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const switchedToMobile = !wasMobileRef.current && isMobile;
    const shouldRecoverMissingScreen = isMobile && activeScreen === null && !loading;
    console.log("[MobileFlowBuilder] viewport check", {
      previousIsMobile: wasMobileRef.current,
      currentIsMobile: isMobile,
      activeScreen,
      switchedToMobile,
      shouldRecoverMissingScreen,
      loading,
    });

    if ((switchedToMobile && activeScreen === null) || shouldRecoverMissingScreen) {
      console.log("[MobileFlowBuilder] initializing activeScreen to locations", {
        reason: switchedToMobile ? "desktop_to_mobile_transition" : "missing_screen_recovery",
      });
      dispatch(navigateTo("locations"));
    }

    wasMobileRef.current = isMobile;
  }, [activeScreen, dispatch, isMobile, loading]);

  return (
    <Box h="100%" w="100%" flex={1}>
      {loading ? <Flex
        justifyContent={"center"} alignItems={"center"} h="100vh" w="100%">
        <Spinner variant={"ring"} size={"sm"} />
      </Flex> :
        renderScreen()}
      <MobileBottomSheet />
      {APP_PLATFORM === Platform.Shopify && !appLoading && <ReviewStickyWidgetV2 />}
    </Box>
  );
};

export default MobileFlowBuilder;
